<template>
  <el-dropdown
    trigger="click"
    @command="handleCommand"
    :class="[
      {
        'color--blue': menuColor == 'blue',
        'color--white': menuColor == 'white',
        'color--transparent': menuColor == 'transparent',
        big: buttonSize === 'big',
        medium: buttonSize === 'medium',
        small: buttonSize === 'small',
        'color--dark-blue':
          menuColor.length > 0 && menuColor.toLowerCase() == 'darkblue'
      },
      'dropdown-el'
    ]"
  >
    <span v-if="type === 'pen'">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 14V11L8.5 4.5L11.5 7.5L5 14H2Z" fill="#62717E" />
        <path
          d="M13 6L10 3L11.2929 1.70711C11.6834 1.31658 12.3166 1.31658 12.7071 1.70711L14.2929 3.29289C14.6834 3.68342 14.6834 4.31658 14.2929 4.70711L13 6Z"
          fill="#62717E"
        /></svg
    ></span>
    <span v-else-if="type == 'Pen'">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 1.58569L14 4.58569L15.8787 2.70701C17.0503 1.53544 18.9497 1.53544 20.1213 2.70701L21.2929 3.87859C22.4645 5.05016 22.4645 6.94965 21.2929 8.12123L7.41421 21.9999H2V16.5857L12.5858 5.99991L11 4.41412L5.70711 9.70701L4.29289 8.2928L11 1.58569ZM14 7.41412L5.63296 15.7812L8.21875 18.3669L16.5858 9.99991L14 7.41412ZM18 8.58569L19.8787 6.70701C20.2692 6.31649 20.2692 5.68332 19.8787 5.2928L18.7071 4.12123C18.3166 3.7307 17.6834 3.7307 17.2929 4.12123L15.4142 5.99991L18 8.58569ZM6.80454 19.7812L4.21875 17.1954L4 17.4141V19.9999H6.58579L6.80454 19.7812Z"
          fill="#62717E"
        />
      </svg>
    </span>
    <span v-else-if="type == 'pointsMenu'">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 7C10.6193 7 9.5 5.88071 9.5 4.5C9.5 3.11929 10.6193 2 12 2C13.3807 2 14.5 3.11929 14.5 4.5C14.5 5.88071 13.3807 7 12 7ZM12 14C10.6193 14 9.5 12.8807 9.5 11.5C9.5 10.1193 10.6193 9 12 9C13.3807 9 14.5 10.1193 14.5 11.5C14.5 12.8807 13.3807 14 12 14ZM9.5 18.5C9.5 19.8807 10.6193 21 12 21C13.3807 21 14.5 19.8807 14.5 18.5C14.5 17.1193 13.3807 16 12 16C10.6193 16 9.5 17.1193 9.5 18.5Z"
          fill="#99A5B3"
        />
      </svg>
    </span>

    <span
      v-else-if="iconUrl || buttonText"
      :class="buttonText.length ? 'dropdown-el--with-text' : ''"
    >
      <Picture v-if="iconUrl" :url="iconUrl" class="content-icon" />
      {{ buttonText }}
    </span>

    <el-dropdown-menu slot="dropdown" class="dropdown-el__list shadow-lvl-2">
      <el-dropdown-item
        v-for="(action, idx) in actions"
        :key="idx"
        :command="action"
        :disabled="disabled"
      >
        <div class="dropdown-el__item" v-if="action">
          <Picture
            v-if="action.icon"
            :url="action.icon"
            class="dropdown-el__item-icon"
          />
          <Icon
            v-else-if="action.id && actionIcons[action.id] && action.id != '0'"
            class="dropdown-el__item-icon"
            :iconName="actionIcons[action.id]"
            :iconColor="dropdownIconColor ? dropdownIconColor : '#0075DB'"
            :disabled="disabled"
          />
          <p class="dropdown-el__item-text">
            {{
              action.lbl && action.lbl.value ? action.lbl.value : action.name
            }}
          </p>
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import Picture from 'Elements/Picture/Picture';
import Icon from 'Elements/Icon/Icon';
export default {
  props: {
    actions: {
      type: [Array, Object],
      default: () => []
    },
    dropdownIconColor: {
      type: String,
      default: () => ''
    },
    menuColor: {
      type: String,
      default: 'transparent'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonSize: {
      type: String,
      default: 'big'
    },
    iconUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      actionIcons: {
        edit: 'Edit',
        edit_publish: 'Pen',
        delete: 'delete-trash',
        duplicate: 'Copy',
        toArchive: 'BoxDownload',
        publish: 'Upload',
        ReplyTo: 'Reply',
        ReplyToAll: 'ReplyAll',
        Forward: 'Forward',
        exit: 'Exit',
        refresh: 'Refresh',
        deactivate: 'upload',
        show: 'EyeOpen',
        hide: 'EyeCrossed'
      }
    };
  },
  components: {
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem,
    'el-dropdown': Dropdown,
    Picture,
    Icon
  },
  methods: {
    handleCommand(arg) {
      this.$emit('handleCommand', arg);
    }
  }
};
</script>

<style lang="scss" scoped>
.big {
  height: 40px;

  .el-dropdown-selfdefine {
    padding: 8px 12px;
  }

  &.color {
    &--dark-blue {
      .el-dropdown-selfdefine {
        &:focus-visible {
          border-radius: 4px;
          outline: 2px solid $blue80;
        }
      }
    }

    &--blue {
      .el-dropdown-selfdefine {
        &:focus-visible {
          border-radius: 4px;
          background-color: $blue8;
          outline: 2px solid $blue80;
        }
      }
    }
  }

  .dropdown-el--with-text {
    padding: 8px 16px;
  }
}

.medium {
  height: 32px;

  .el-dropdown-selfdefine {
    padding: 4px 12px;

    &:focus-visible {
      border-radius: 4px;
      background-color: $blue8;
      outline: 2px solid $blue80;
    }
  }
}

.small {
  height: 24px;

  .el-dropdown-selfdefine {
    padding: 0;

    &:focus-visible {
      border-radius: 4px;
      background-color: $blue8;
      outline: 2px solid $blue80;
    }
  }
}

.dropdown-el {
  width: auto;
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 4px;

  &--with-text {
    padding: 0 12px;
  }

  .without-text {
    padding: 8px;
  }

  .img {
    width: 24px;
    height: 24px;
  }

  span {
    cursor: pointer;
    color: #0075db;
    font-family: 'Roboto Medium';
    font-size: 16px;
    line-height: 24px;
    display: flex;
    gap: 6px;
  }

  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 40px;
    border-radius: 4px;
    cursor: pointer;

    &-icon {
      margin-right: 8px;
      filter: invert(72%) sepia(11%) saturate(382%) hue-rotate(172deg)
        brightness(90%) contrast(91%);
    }

    &-text {
      margin: 0;
      color: $black-190;
      font-size: 15px;
      font-family: 'Roboto', sans-serif;
      line-height: 24px;
      cursor: pointer;
    }
  }

  &__list {
    margin-top: 4px !important;
  }
}

.color {
  &--blue {
    background-color: $blue8;

    .content-icon {
      filter: $bluePicture;
    }

    &:focus,
    &:focus-visible {
      background-color: $blue8;
      outline: 2px solid $blue80;
    }

    &:hover {
      background-color: $blue12 !important;
    }
  }

  &--transparent {
    background-color: transparent;

    .content-icon {
      filter: $bluePicture;
    }

    &:focus,
    &:focus-visible {
      color: $blue64;
      outline: 2px solid $blue80 !important;
    }
  }

  &--white {
    background-color: $white;

    .content-icon {
      filter: $greyPicture;
    }

    span {
      color: $grey40;
    }

    &:hover {
      outline: 1px solid $blue40;
    }

    &:focus,
    &:focus-visible {
      outline: 2px solid $blue80 !important;
    }
  }

  &--dark-blue {
    background-color: $blue40;

    .content-icon {
      filter: $whitePicture;
    }

    span {
      color: $white;
    }

    &:hover {
      background-color: $blue64;
    }

    &:focus,
    &:focus-visible {
      background-color: $blue40 !important;
      outline: 2px solid $blue80 !important;
    }
  }
}

.el-dropdown-menu {
  border-radius: 4px;
  padding: 0;
  width: auto;

  &__item {
    // border-radius: 4px;
    padding: 0 16px;

    &.is-disabled {
      & ::v-deep .dropdown-el__item-text {
        color: $black-40;
      }
    }
  }
}
</style>
